import React from 'react'
import PaymentMethods from './PaymentMethods'
import ProductShippingInfo from './ProductShippingInfo'
import { CountryDetails } from '../services/api'
import { IEstimatedDispatchDays } from '@/context/ProductDataStore'
import { ButtonVariant, getVariantClasses } from './Button'

interface ProductActionButtonProps {
  isLoading: boolean
  onAddToBasket: () => void
  currencySymbol: string
  freeDeliveryThreshold: number
  countryDetails: CountryDetails | null
  formattedUpdateDate: string
  estimatedDispatchDays?: IEstimatedDispatchDays | null
  buttonVariant?: ButtonVariant | null
  primaryTextColor?: string
  iconColor?: string
  buttonLabel?: string
  isDisabled?: boolean
}

const ProductActionButton: React.FC<ProductActionButtonProps> = ({
  isLoading,
  onAddToBasket,
  currencySymbol,
  freeDeliveryThreshold,
  countryDetails,
  formattedUpdateDate,
  estimatedDispatchDays,
  buttonVariant,
  primaryTextColor,
  iconColor,
  buttonLabel,
  isDisabled = false
}) => {
  const isButtonDisabled = isLoading || isDisabled
  const variantClassName = getVariantClasses(buttonVariant ?? 'solid-orange')

  return (
    <div className="flex flex-col gap-4">
      <button
        className={`flex items-center p-4 ${variantClassName} justify-center w-full rounded-xl font-headline leading-none text-2xl
                    transition-all ease-kibu duration-200 items-center cursor-pointer border border-2 border-transparent
                    hover:rounded-2xl hover:shadow-button-hover hover:brightness-105 hover:border-black/10 hover:scale-[1.02]
                    ${isButtonDisabled ? 'opacity-50 cursor-not-allowed hover:scale-100 hover:brightness-100 hover:shadow-none' : ''}`}
        onClick={onAddToBasket}
        disabled={isButtonDisabled}
      >
        {isLoading ? 'Loading...' : (buttonLabel || 'Add to Basket')}
      </button>
      <PaymentMethods />
      <ProductShippingInfo
        currencySymbol={currencySymbol}
        freeDeliveryThreshold={freeDeliveryThreshold}
        countryDetails={countryDetails}
        formattedUpdateDate={formattedUpdateDate}
        estimatedDispatchDays={estimatedDispatchDays}
        primaryTextColor={primaryTextColor}
        iconColor={iconColor}
      />
    </div>
  )
}

export default ProductActionButton
